import { PUBLIC_IDM_API_URL_ENV } from 'tools/environments';
import { GetForgotPasswordResponse } from './types';

export const getForgotPassword = async (lang = 'en', pwrt?: string) => {
	const search = window.location.search;
	const queryParams = [`culture=${lang}`];
	if (search) queryParams.push(search.slice(1));
	const url = `${PUBLIC_IDM_API_URL_ENV}/forgotten${pwrt ? '/reset': ''}?${queryParams.join('&')}`;
	return fetch(url, {
		method: 'GET',
		credentials: 'include',
	})
	.then((res) => {
		if (res.ok) return res.json() as Promise<GetForgotPasswordResponse>;
	})
	.catch((error) => {
		console.error('Profile request error: ', error);
		throw error;
	});
};
